export default __webpack_public_path__ + "static/media/20-MidtjyskAlbyg.80e1dce0.png";